<app-no-content *ngIf="!data || !data.details"
                title="No details available"
                i18n-title="List Item|List Item details no details title@@list-item-details-no-data-title"></app-no-content>

<mat-list *ngIf="data && data.details" class="list-container no-focus">
  <mat-list-item *ngFor="let detail of data.details" class="list-option no-focus">
    <div class="list-item-content full-width" fxLayout="row">
      <div *ngIf="detail.value" fxLayout="column" fxFlex="100%">
        <span *ngIf="detail.name" class="text-disabled-color mat-small">{{detail.name}}</span>
        <span class="word-wrap">{{isDate(detail.value) ? (detail.value | date:'medium') : detail.value}}</span>
      </div>
    </div>
  </mat-list-item>
</mat-list>
